import Vue from 'vue'
import { sanitizePrice } from '../utils/toPrice'

// v-price: pozwala wpisać tylko liczby z jedną kropką i max dwiema cyframi po niej,
// , zamienia na . i blokuje pozostałe znaki. Działa też na <b-input> (wewnętrzny <input>).
Vue.directive('price', {
  bind (el) {
    const input = el.tagName === 'INPUT' ? el : el.querySelector('input')
    if (!input) {
      return
    }

    el.decimalHandler = () => {
      const sanitized = sanitizePrice(input.value)
      if (sanitized !== input.value) {
        input.value = sanitized
        // ponowny event, aby v-model (również Buefy) dostał oczyszczoną wartość
        input.dispatchEvent(new Event('input'))
      }
    }

    input.addEventListener('input', el.decimalHandler)
  },
  unbind (el) {
    const input = el.tagName === 'INPUT' ? el : el.querySelector('input')
    if (input && el.decimalHandler) {
      input.removeEventListener('input', el.decimalHandler)
    }
  }
})

Vue.directive('custom-click-outside', {
  bind (el, binding, vnode) {
    el.clickOutsideEvent = (event) => {
      if (!(el === event.target || el.contains(event.target))) {
        // poprawka aby nie działało podczas użycia modalu w ckeditorze
        const element = document.body.getElementsByClassName('cke_dialog_background_cover')
        if (!((element && element[0] && element[0].style && element[0].style.display !== 'none') || (event && event.target && event.target.classList.contains('cke_dialog_ui_button')))) {
          vnode.context[binding.expression](event)
        }
      }
    }
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  }
})
